import React, { createContext, useState, useCallback, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { omit } from 'lodash'

const initialState = []
export const Context = createContext(initialState)

export default function ArchivedAdNotificationProvider({ children }) {
  const history = useHistory()
  const [visible, setVisible] = useState(false)
  const { pathname, search } = useLocation()
  const { archived } = queryString.parse(search)

  const close = useCallback(() => {
    setVisible(false)
  }, [])

  useEffect(() => {
    if (archived === '1') {
      history.replace({
        pathname,
        search: queryString.stringify(omit(queryString.parse(search), 'archived')),
        state: {
          dontScroll: true,
        },
      })

      setVisible(true)
    }
  }, [history, pathname, archived, search])

  const value = useMemo(() => ({ visible, close }), [visible, close])

  return <Context.Provider value={value}>{children}</Context.Provider>
}

ArchivedAdNotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
